const convertToISO = (dateString: string) => {
	const monthMap: Record<string, string> = {
		Jan: '01',
		January: '01',
		Feb: '02',
		February: '02',
		Mar: '03',
		March: '03',
		Apr: '04',
		April: '04',
		May: '05',
		Jun: '06',
		June: '06',
		Jul: '07',
		July: '07',
		Aug: '08',
		August: '08',
		Sep: '09',
		September: '09',
		Oct: '10',
		October: '10',
		Nov: '11',
		November: '11',
		Dec: '12',
		December: '12',
	};

	const formatDay = (day: string): string => {
		if (day.length === 1) return `0${day}`;
		return day;
	};

	const formatMonth = (month: string): string => {
		if (monthMap[month]) return monthMap[month];
		if (month.length === 1) return `0${month}`;
		return month;
	};

	const formatYear = (year: string): number => {
		const yearAsNumber = Number(year);
		if (yearAsNumber < 100) return yearAsNumber + 2000;
		return yearAsNumber;
	};

	// Regular expression to match date formats
	const regex = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})$/;

	const match = dateString.match(regex);

	if (match) {
		const [, day, month, year] = match;

		const formattedDay = formatDay(day);
		const formattedMonth = formatMonth(month);
		const formattedYear = formatYear(year);
		return `${formattedYear}-${formattedMonth}-${formattedDay}`;
	}
	return null;
};

export const getDatePickerFieldValue = (defaultValue: unknown) => {
	if (typeof defaultValue === 'string') {
		return convertToISO(defaultValue);
	}
	return null;
};
